import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import StringToHSL from '../StringToHSL';
import styles from './Initials.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
const cln = classnames.bind(styles);
const getInitials = str => str.trim().split(/\s|\./, 2).map(word => word[0]).join('');

/**
 * This component renders initials with a background color calculated from the provided text.
 */
function Initials({
  children,
  size = 'compact',
  color,
  className,
  colorBase,
  lightness,
  saturation,
  as: Container = 'div',
  generator = getInitials,
  style = {},
  ...rest
}) {
  return /*#__PURE__*/_jsx(StringToHSL, {
    string: colorBase || children,
    lightness: lightness,
    saturation: saturation,
    children: HSLColor => /*#__PURE__*/_jsx(Container, {
      className: cln('initials', className, `initials--${size}`),
      style: {
        backgroundColor: color || HSLColor,
        ...style
      },
      ...rest,
      children: generator(children)
    })
  });
}
Initials.propTypes = {
  /** String representing valid HTML tag (e.g. 'button') which should be used as a container */
  as: PropTypes.string,
  /**
   * String which should be used to get initials. By default initials are generated by splitting the provided
   * string by whitespace or dots:
   * ab -> A
   * a.b -> AB
   * foo.bar baz -> FB
   * foo bar -> FB
   *
   * You can provide "generator" prop to overwrite this algorithm
   */
  children: PropTypes.string.isRequired,
  /** Optional CSS valid color format string to overwrite the default coloring algorithm */
  color: PropTypes.string,
  /**
   * On of predefined sizes */
  size: PropTypes.oneOf(['big', 'small', 'compact']),
  /**
   * If provided, the background will be calculated using this prop, otherwise
   * the string provided as "children" will be used
   */
  colorBase: PropTypes.string,
  className: PropTypes.string,
  /** Custom initials generator which will receive the "children" as the first argument */
  generator: PropTypes.func,
  /** A number between 0 and 100 */
  saturation: PropTypes.number,
  /** A number between 0 and 100 */
  lightness: PropTypes.number,
  style: PropTypes.object
};
export default Initials;